import { ProjectStatusEnum } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { Badge } from 'uikit';

import * as React from 'react';

import './ProjectStatus.css';

export const statusCellProps: Record<
    ProjectStatusEnum,
    { label: string; status?: BadgePropStatus; className?: string }
> = {
    [ProjectStatusEnum.InCalculation]: { label: 'На формировании', status: 'normal' },
    [ProjectStatusEnum.Calculated]: { label: 'Сформирован', status: 'success' },
    [ProjectStatusEnum.Canceled]: { label: 'Отменен', status: 'system' },
    [ProjectStatusEnum.InImplementation]: { label: 'На реализации', className: 'in-implementation' },
    [ProjectStatusEnum.Completed]: { label: 'Завершен', status: 'success' },
    [ProjectStatusEnum.Delayed]: { label: 'Отложен', status: 'system' },
};

export const getStatusLabel = (statusId: ProjectStatusEnum) => statusCellProps[statusId]?.label ?? 'Не указан';

export const ProjectStatus = ({ id }: { id: ProjectStatusEnum }) => <Badge {...statusCellProps[id]} />;

ProjectStatus.displayName = 'ProjectStatus';
